import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query'
import { createApi } from '@reduxjs/toolkit/query/react'
import { api as endpoints } from './generated'
import { RootStateWithPatientAuth, PATIENT_AUTH_REDUCER_KEY } from '../../patientAuth'
import { CustomErrorResponse } from '../..'


export const verifyApiExternal = createApi({
  reducerPath: 'verifyApiExternal',
  tagTypes: [],
  endpoints,
  keepUnusedDataFor: 0,
  baseQuery: graphqlRequestBaseQuery<CustomErrorResponse>({
    url: `https://${process.env.VERIFY_API_DOMAIN}/graphql`,
    prepareHeaders: (headers, api) => {
      const state = api.getState() as RootStateWithPatientAuth
      const accessToken = state[PATIENT_AUTH_REDUCER_KEY].session?.access_token
      if (accessToken) {
        headers.set('Authorization', `Bearer ${accessToken}`)
      }
      return headers
    },
    customErrors: ({ message, stack, name, response }) => ({
      message,
      stack: stack || '',
      name,
      response,
    }),
  }),
})

export type VerifyApiExternalType = typeof verifyApiExternal